import { Component, OnInit, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import {AppComponent} from '../../app.component';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { element } from 'protractor';
import { AlertService } from '../../alertpopup/_alert';
export class UserData {
  EDList: EscalationUserData [];
  UserData: UserMaster[];
}
export class UserMaster {
  ID: any;
  UserName: string;
  Email: string;
  Mobile: any;
}
export class InsertNotifyData {
  EDList: [];
  recEnable: string;
}
export class EscalationUserData {
  ID: any;
  UserName: string;
  SelectedL1Email: number [];
  SelectedL2Email: number [];
  SelectedL3Email: number [];
  L1Day: string;
  L1interval: string;
  L1Users = [];
  L1Email: string;
  L1recEnable: any;
  L2Day: string;
  L2interval: string;
  L2Users = [];
  L2Email: string;
  L2recEnable: any;
  L3Day: string;
  L3interval: string;
  L3Users = [];
  L3Email: string;
  L3recEnable: any;
}

@Component({
    selector: 'app-escalation',
    templateUrl: './escalation.component.html',
    styleUrls: ['./escalation.component.css'],
    standalone: false
})
export class EscalationComponent implements OnInit {
  @Input() EscalationData: EscalationUserData[];
  url: string;
  Report: any;
  Features: any;
  MsgType: number;
  DisplayMessage: string;
  MainID: string;
  FormSearchEscalation: FormGroup;
  Form: FormGroup;
  L1isSelected: boolean;
  L2isSelected: boolean;
  L3isSelected: boolean;
  UserMasterDetail: any;
  HideContent: string;
  ReportID: string;
  L1MailRoute: string;
  L2MailRoute: string;
  L3MailRoute: string;
  options = {
    autoClose: true,
    keepAfterRouteChange: false
};
  constructor(private router: Router, private http: HttpClient, private formBuilder: FormBuilder, protected alertService: AlertService) { this.url = AppComponent.baseURL; }

  ngOnInit() {
    this.HideContent = "!isHidden";
    this.MsgType = 1; // Loading
    this.FormSearchEscalation = this.formBuilder.group ({
      ReportName: [''] });
    this.FormSearchEscalation.patchValue({ ReportName: '0' });
    // Fetch Module in Notification
    this.http.get(this.url + 'AlertNotificationDetail/GetEscalationReportName') .subscribe( (data) => {
      this.Report = JSON.parse(data.toString());
    console.log(this.Report); });
    this.L1isSelected = false;
    this.L2isSelected = false;
    this.L3isSelected = false;
    const formGroup = {};
    this.Form = new FormGroup(formGroup);

  }


    SaveData()  {
      // tslint:disable-next-line: max-line-length
      this.http.post(this.url + 'AlertNotificationDetail/Insert_Escalation_Data', this.Form.value) .subscribe( (data) => {
        this.alertService.success('Successfully Submit' , this.options);
        if (data == null) { this.alertService.error('Some Error In Entered Record' , true);
       }});
    }
    onL1Change(ischeck)  {
      for (var val of this.EscalationData) {
        (this.Form.get(String('1|recEnable|' + val.ID)) as FormControl).patchValue(ischeck.target.checked==false?0:1);
     }
    }
    onL2Change(ischeck)  {
      for (var val of this.EscalationData) {
        (this.Form.get(String('2|recEnable|' + val.ID)) as FormControl).patchValue(ischeck.target.checked==false?0:1);
     }
    }

  print() {
    window.print();
  }
    onL3Change(ischeck)  {
      for (var val of this.EscalationData) {
        (this.Form.get(String('3|recEnable|' + val.ID)) as FormControl).patchValue(ischeck.target.checked==false?0:1);
     }
    }
    onReportNameSelect(ReportID) {
      this.ReportID = ReportID;
      if (ReportID == 207046000) { this.L1MailRoute = '/editor/M74'; this.L2MailRoute = '/editor/M75'; this.L3MailRoute = '/editor/M74';}
      if (ReportID == 207052000) { this.L1MailRoute = '/editor/M80'; this.L2MailRoute = '/editor/M81'; this.L3MailRoute = '/editor/M82';}
      if (ReportID == 207054000) { this.L1MailRoute = '/editor/M71'; this.L2MailRoute = '/editor/M72'; this.L3MailRoute = '/editor/M73';}
      if (ReportID == 207040000) { this.L1MailRoute = '/editor/M77'; this.L2MailRoute = '/editor/M78'; this.L3MailRoute = '/editor/M79';}
      const formGroup = {};
      this.Form = new FormGroup(formGroup);
      this.HideContent = "";
      this.L1isSelected = false;
      this.http.get(this.url + 'AlertNotificationDetail/Fetch_User_Escalation_Listing?ReportID=' + ReportID)
      .subscribe( (data) => {
        if (data == null || data.toString() == "[]") {
          this.MsgType = 2; // No Data Found
          this.DisplayMessage = "No Data Found";
          let escalationUserData: EscalationUserData [] = null;
          let userMaster: UserMaster[] = null;
        } else {
        console.log(data);
        this.MsgType = 0; // No Message
        let userData: UserData = JSON.parse(data.toString());
        // let escalationUserData: EscalationUserData [] = userData.NDList;
        this.EscalationData = userData.EDList;
        // let userMaster: UserMaster[] = userData.UserData;
        this.UserMasterDetail = userData.UserData;
        if (this.EscalationData[0].L1recEnable == 0) {

          this.L1isSelected = false;
        } else { this.L1isSelected = true;  }
        if (this.EscalationData[0].L2recEnable == 0) {
          this.L2isSelected = false;
        } else { this.L2isSelected = true;}
        if (this.EscalationData[0].L3recEnable == 0) {
          this.L3isSelected = false;
        } else { this.L3isSelected = true; }
        }
        this.EscalationData.forEach(escalationData => {
           formGroup['ReportID'] = new FormControl("");
           formGroup['1|ID|' + escalationData.ID] = new FormControl("");
           formGroup['1|Day|' + escalationData.ID] = new FormControl("");
           formGroup['1|interval|' + escalationData.ID] = new FormControl("");
           formGroup['1|Users|' + escalationData.ID] = new FormControl("");
           formGroup['1|Email|' + escalationData.ID] = new FormControl("");
           formGroup['1|recEnable|' + escalationData.ID] = new FormControl("");
           formGroup['2|Day|' + escalationData.ID] = new FormControl("");
           formGroup['2|interval|' + escalationData.ID] = new FormControl("");
           formGroup['2|Users|' + escalationData.ID] = new FormControl("");
           formGroup['2|Email|' + escalationData.ID] = new FormControl("");
           formGroup['2|recEnable|' + escalationData.ID] = new FormControl("");
           formGroup['3|Day|' + escalationData.ID] = new FormControl("");
           formGroup['3|interval|' + escalationData.ID] = new FormControl("");
           formGroup['3|Users|' + escalationData.ID] = new FormControl("");
           formGroup['3|Email|' + escalationData.ID] = new FormControl("");
           formGroup['3|recEnable|' + escalationData.ID] = new FormControl("");
           this.Form = new FormGroup(formGroup);
         });
        (this.Form.get(String('ReportID')) as FormControl).patchValue(ReportID);
        for (var val of this.EscalationData) {
           (this.Form.get(String('1|ID|' + val.ID)) as FormControl).patchValue(val.ID);
           (this.Form.get(String('1|Day|' + val.ID)) as FormControl).patchValue(val.L1Day);
           (this.Form.get(String('1|interval|' + val.ID)) as FormControl).patchValue(val.L1interval);
           val.SelectedL1Email = val.L1Users.toString().split(',').map(Number);
           (this.Form.get(String('1|Users|' + val.ID)) as FormControl).patchValue(val.SelectedL1Email);
           (this.Form.get(String('1|Email|' + val.ID)) as FormControl).patchValue(val.L1Email);
           (this.Form.get(String('1|recEnable|' + val.ID)) as FormControl).patchValue(val.L1recEnable);
           (this.Form.get(String('2|Day|' + val.ID)) as FormControl).patchValue(val.L2Day);
           (this.Form.get(String('2|interval|' + val.ID)) as FormControl).patchValue(val.L2interval);
           val.SelectedL2Email = val.L2Users.toString().split(',').map(Number);
           (this.Form.get(String('2|Users|' + val.ID)) as FormControl).patchValue(val.SelectedL2Email);
           (this.Form.get(String('2|Email|' + val.ID)) as FormControl).patchValue(val.L2Email);
           (this.Form.get(String('2|recEnable|' + val.ID)) as FormControl).patchValue(val.L2recEnable);
           (this.Form.get(String('3|Day|' + val.ID)) as FormControl).patchValue(val.L3Day);
           (this.Form.get(String('3|interval|' + val.ID)) as FormControl).patchValue(val.L3interval);
           val.SelectedL3Email = val.L3Users.toString().split(',').map(Number);
           (this.Form.get(String('3|Users|' + val.ID)) as FormControl).patchValue(val.SelectedL3Email);
           (this.Form.get(String('3|Email|' + val.ID)) as FormControl).patchValue(val.L3Email);
           (this.Form.get(String('3|recEnable|' + val.ID)) as FormControl).patchValue(val.L3recEnable);
        }
      },
      (error) => {
         this.MsgType = 3; // Error Message
         this.DisplayMessage = error.message;
       }
    );

    }
}
